import { AxiosResponse } from "axios";

// Models
import { Result } from "@/main/models/common/resultResponse";
import { DeleteQuoteAttachmentRequest, SaveQuoteAttachmentsRequest } from "@/main/models/request";

export abstract class IQuoteAttachmentApi {
	abstract saveAttachments(request: SaveQuoteAttachmentsRequest): Promise<AxiosResponse<Result<boolean>>>;

	abstract deleteAttachment(request: DeleteQuoteAttachmentRequest): Promise<AxiosResponse<Result<boolean>>>;
}
